export default "/_next/static/images/1ff709166d1d986c43948abf9cb029f0.png";